<div id="attribute">
    <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <span>
            Lead Owner Search
        </span>
        <button [attr.guide]="'lead-owner-search-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-11" style="overflow-x: auto;">
        <div class="editSets" fxLayout="column">
            <calsoft-list [disableFilter]="1" [progress]="spinner" (filterChangeColumn)="onFilterChangeColumn($event)"
                (filterChange)="onFilterChange($event)" name="Lead Owner Search" [columns]="columns">

                <div id="responsieTable" class="container">
                    <div [ngClass]="productList.length>=5?'minimum':'none'">
                        <table>
                            <tbody>
                                <tr fxHide fxShow.gt-md>
                                    <th data-label="Lead Name">Lead Name</th>
                                    <th data-label="Lead PhoneNumber">Lead Phone Number</th>
                                    <th data-label="Product Name">Product Name</th>
                                    <th data-label="Lead Status">Lead Status</th>
                                    <th data-label="Lead Owner">Lead Owner Mail</th>
                                </tr>
                                <tr *ngFor="let leadCalls of productList; let i = index">
                                    <td data-label="Lead Name">{{ leadCalls.name }}</td>
                                    <td data-label="Lead PhoneNumber">{{ leadCalls.phoneNumber }}</td>
                                    <td data-label="Product Name">{{ leadCalls.product }}</td>
                                    <td data-label="Lead Status">{{ leadCalls.statusName }}</td>
                                    <td data-label="Lead Owner">{{ leadCalls.ownerEmail }}</td>
                                    <!-- Ensure this is present -->
                                </tr>

                            </tbody>
                        </table>
                        <div fxLayout="row" *ngIf="productList.length==0" fxLayoutAlign="center center">
                            <span>No Records Found</span>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                        [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                    </mat-paginator>
                </div>
            </calsoft-list>
        </div>
    </div>
</div>